import ManageProductTable from './ManageProductTable'

const ManageProduct = {
  Table: ManageProductTable,
}

export default ManageProduct
